import { Injectable } from '@angular/core';
import { DocumentService } from '@api/services/document.service';

@Injectable({
	providedIn: 'root',
})
export class UserImageService {
	private _blankAvatar = 'assets/img/blank-user.png';
	private _image: any;

	constructor(private _imageService: DocumentService) {}

	get image() {
		return this._image || this._blankAvatar;
	}

	set image(value) {
		this._image = value;
	}

	public update(imageId): void {
		if (imageId) {
			this._imageService.getImageUrl(imageId).subscribe((image) => (this.image = image));
		}
	}
}
